<template>
  <div class="evento-container" ref="container">
    <!-- Card 1: Ceremonia Religiosa -->
    <div class="evento-card" ref="card1">
      <img src="@/assets/10.png" alt="Ceremonia Religiosa" class="evento-icono1" />
      <p class="evento-titulo">Ceremonia Religiosa</p>
      
      <p class="evento-aclaracion"></p>
      
      <p class="evento-fecha">Sábado 10 de Octubre</p>
      <p class="evento-lugar">Sagrado Corazón de Jesús
</p>
      <p class="evento-direccion">Progreso, Zona Centro, Frontera, Coahuila.</p>
      <p class="evento-hora">6:00 P.M.</p>
      
      
      <a href="https://maps.app.goo.gl/Nw9h7QiNKAeJYqcZ8" class="btn-mapa" target="_blank">VER MAPA</a>
    </div>

    <!-- Línea divisoria o decorativa opcional -->
    <div class="linea-central" ref="lineaCentral"></div>

    <!-- Card 2: Recepción / Celebración -->
    <div class="evento-card" ref="card2">
      <img src="@/assets/8.png" alt="Celebración" class="evento-icono1" />
      <p class="evento-titulo">Celebración</p>
      
      <p class="evento-aclaracion"></p>
      
      <p class="evento-fecha">Sábado 10 de Octubre</p>
      <p class="evento-lugar">Quinta Atardecer</p>
      <p class="evento-direccion">Ejido Fresnillo, Frontera Coahuila.</p>
      <p class="evento-hora">9:00 P.M.</p>
      
      
      <a href="https://maps.app.goo.gl/qbhVACJ5txu3Yvow5" class="btn-mapa" target="_blank">VER MAPA</a>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'EventoSection',
  setup() {
    const container = ref(null)
    const card1 = ref(null)
    const card2 = ref(null)
    const lineaCentral = ref(null)

    onMounted(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Animación consecutiva en secuencia (Timeline)
              const tl = gsap.timeline()

              // 1. Aparece la primera tarjeta
              if (card1.value) {
                tl.fromTo(
                  card1.value, 
                  { opacity: 0, y: 40 }, 
                  { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' }
                )
              }

              // 2. Se despliega la línea central (si existe en el DOM)
              if (lineaCentral.value) {
                tl.fromTo(
                  lineaCentral.value, 
                  { scaleY: 0 }, 
                  { scaleY: 1, transformOrigin: 'top', duration: 0.5, ease: 'power1.inOut' },
                  '-=0.3' // Inicia ligeramente antes de que termine la anterior
                )
              }

              // 3. Aparece la segunda tarjeta inmediatamente después
              if (card2.value) {
                tl.fromTo(
                  card2.value, 
                  { opacity: 0, y: 40 }, 
                  { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' },
                  '-=0.2'
                )
              }

              observer.unobserve(entry.target)
            }
          })
        },
        { threshold: 0.15 } // Dispara la animación apenas asoma la sección
      )

      if (container.value) observer.observe(container.value)
    })

    return { container, card1, card2, lineaCentral }
  }
}
</script>
<style scoped>
.evento-container {
  background-image: url('@/assets/7.png');
  background-size: cover;
  background-position: center;
  padding: 60px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #121111;
}

.evento-card {
  text-align: center;
  margin-bottom: 30px;
  max-width: 340px; /* Un poco más ancho para asegurar espacio */
  opacity: 0;
}

.evento-icono1 {
  width: 78px;
  margin-bottom: 12px;
}

.evento-titulo {
  font-family: 'Corinthia', cursive;
  font-size: 54px;
  color: #121111;
  margin: 0 0 2px;
}

.evento-aclaracion {
  font-family: 'Corinthia', cursive;
  font-size: 38px;
  color: #121111; /* Mismo color principal para asegurar lectura */
  margin: 0 0 20px;
}

.evento-fecha {
  font-family: 'padres', serif;
  font-size: 18px;
  color: #121111;
  margin-bottom: 6px;
}

.evento-lugar {
  font-family: 'padres', serif;
  font-size: 19px;
  font-weight: bold;
  color: #121111;
  margin-bottom: 6px;
}

.evento-direccion {
  font-family: 'padres', serif;
  font-size: 18px;
  color: #121111;
  margin-bottom: 6px;
}

.evento-hora {
  font-family: 'fa', sans-serif;
  font-size: 22px;
  color: #121111;
  font-style: italic;
  margin-bottom: 20px;
}

.evento-nota {
  font-family: 'padres', serif;
  font-size: 16px; /* Subido de 15px a 16px */
  font-style: italic;
  color: #121111; /* Cambiado a color oscuro puro para que no se pierda en el fondo */
  margin-top: 10px;
  margin-bottom: 25px;
  display: block;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.btn-mapa {
  background: transparent;
  border: 1px solid #292929;
  color: #1c1b1b;
  font-size: 18px;
  padding: 8px 22px;
  text-decoration: none;
  font-family: 'padres', serif;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  display: inline-block;
}

.btn-mapa:hover {
  background: #121111;
  color: #fff;
}

.linea-division {
  width: 2px;
  height: 40px;
  background: #121111; /* Cambiado a oscuro por si el fondo es claro y no se veía */
  margin: 20px 0;
  transform: scaleY(0);
}
</style>